;(function () {
	const initCardList = () => {
		const texts = document.querySelectorAll('.card-list__text')
		const images = document.querySelectorAll('.card-list__item_img_active')
		const items = document.querySelectorAll('.card-list__item_active')

		if (items.length === 0) return

		const textAlwaysVisible = items[0].dataset.textAlwaysVisible === 'true'
		const isDesktop = window.matchMedia('(min-width: 990px)').matches

		if (textAlwaysVisible != true) {
			const setImageHeight = (image, textHeight, fullHeight) => {
				if (!image) return
				// Use calc() for absolutely positioned elements - 100% refers to positioned parent (item)
				image.style.height = fullHeight ? '100%' : `calc(100% - ${textHeight}px)`
			}

			texts.forEach((text, i) => {
				const image = images[i]
				const item = items[i]

				if (!item || !image) return

				// Skip if already initialized
				if (item.dataset.hoverInitialized === 'true') return

				// Wait for layout to calculate proper heights
				const initHeight = () => {
					// Force a reflow to ensure accurate measurements
					item.offsetHeight
					const textHeight = text.offsetHeight

					if (isDesktop) {
						setImageHeight(image, textHeight, true)

						const handleHover = (fullHeight) => {
							if (window.matchMedia('(min-width: 990px)').matches) {
								// Recalculate text height on hover in case it changed
								const currentTextHeight = text.offsetHeight
								setImageHeight(image, currentTextHeight, fullHeight)
							}
						}

						// Attach hover to link if it exists, otherwise to the item
						const link = item.querySelector('.card-list__item-link')
						const hoverTarget = link || item

						hoverTarget.addEventListener('mouseenter', () => handleHover(false))
						hoverTarget.addEventListener('mouseleave', () => handleHover(true))
						
						// Mark as initialized
						item.dataset.hoverInitialized = 'true'
					} else {
						setImageHeight(image, textHeight, false)
						item.dataset.hoverInitialized = 'true'
					}
				}

				// Use requestAnimationFrame to ensure layout is complete
				requestAnimationFrame(initHeight)
			})
		}
	}

	document.addEventListener('DOMContentLoaded', function () {
		initCardList()
		document.addEventListener('shopify:section:load', function () {
			// Reset initialization flags when section reloads
			document.querySelectorAll('.card-list__item_active').forEach(item => {
				item.dataset.hoverInitialized = 'false'
			})
			initCardList()
		})
	})
	window.addEventListener('resize', function () {
		// Reset initialization flags on resize
		document.querySelectorAll('.card-list__item_active').forEach(item => {
			item.dataset.hoverInitialized = 'false'
		})
		initCardList()
	})
})()

;(function () {

	const initSwipers = () => {
		$('.card-list-section').each(function () {
			const $section = $(this)
			const id = $section.attr('id')
			const $box = $section.find('.card-list')
			
			if ($box.find('.swiper').length === 0) return
			
			if ($box.data('swiper-initialized')) return
			
			const swipeOnMobile = $box.data('swipe-mobile') === 'true' || $box.data('swipe-mobile') === true
			const swipeOnDesktop = $box.data('swipe-desktop') === 'true' || $box.data('swipe-desktop') === true
			const isMobile = window.innerWidth <= 576
			const isDesktop = window.innerWidth > 576
			
			console.log((isMobile && !swipeOnMobile) || (isDesktop && !swipeOnDesktop), isMobile, swipeOnMobile, isDesktop, swipeOnDesktop)
			// Only initialize if swipe is enabled for current breakpoint
			if ((isMobile && !swipeOnMobile) || (isDesktop && !swipeOnDesktop)) {
				return
			}
			
			const autoplay = $box.data('autoplay')
			const stopAutoplay = $box.data('stop-autoplay')
			const delay = 4 * 1000

			let autoplayParm = {}
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				}
			}

			// Get columns per row from data attribute
			const columnsPerRow = parseInt($box.data('columns-per-row')) || parseInt($box.attr('data-columns-per-row')) || 3
			
			// Determine slides per view based on device and settings
			let baseSlidesPerView = 1
			let breakpointsConfig = {}
			
			if (isMobile && swipeOnMobile) {
				// Mobile: 1 slide per view
				baseSlidesPerView = 1
			} else if (isDesktop && swipeOnDesktop) {
				// Desktop: use columns per row setting
				baseSlidesPerView = columnsPerRow
				// Set breakpoint to ensure it works on resize
				breakpointsConfig = {
					576: {
						slidesPerView: columnsPerRow,
						spaceBetween: 16,
					},
				}
			}

			const swiperParms = {
				slidesPerView: baseSlidesPerView,
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				loop: false,
				spaceBetween: 16,
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
					type: 'bullets',
				},
				...(Object.keys(breakpointsConfig).length > 0 ? { breakpoints: breakpointsConfig } : {}),
				...autoplayParm,
			}

			console.log(swiperParms)

			const swiperInstance = new Swiper(`#${id} .swiper`, swiperParms)
			
			// Force update after a brief delay to ensure container has correct width
			setTimeout(() => {
				if (isDesktop && swipeOnDesktop) {
					// Get the actual swiper container element
					const swiperEl = document.querySelector(`#${id} .swiper`)
					if (swiperEl) {
						// Force Swiper to recalculate sizes using updateSize
						swiperInstance.params.slidesPerView = columnsPerRow
						if (swiperInstance.breakpoints) {
							swiperInstance.breakpoints.update()
						}
						swiperInstance.updateSize()
						swiperInstance.update()
						swiperInstance.updateSlidesClasses()
						swiperInstance.updateSlides()
					}
				}
			}, 100)
			
			$box.data('swiper-initialized', true)
			$box.data('swiper-instance', swiperInstance)
		})
	}

	// Only remove swiper-slide classes if swipe is not enabled on desktop
	const removeSwiperSlidesIfNeeded = () => {
		if (window.innerWidth > 576) {
			document.querySelectorAll('.card-list-section').forEach((section) => {
				const $box = $(section).find('.card-list')
				const swipeOnDesktop = $box.data('swipe-desktop') === 'true' || $box.data('swipe-desktop') === true
				
				if (!swipeOnDesktop) {
					const slides = section.querySelectorAll('.card-list__list .swiper-slide')
					slides.forEach((slide) => {
						slide.classList.remove('swiper-slide')
					})
				}
			})
		}
	}

	document.addEventListener('DOMContentLoaded', function () {
		removeSwiperSlidesIfNeeded()
		initSwipers()

		document.addEventListener('shopify:section:load', function () {
			removeSwiperSlidesIfNeeded()
			initSwipers()
		})
	})

	window.addEventListener('resize', function () {
		// Reinitialize swipers on resize to handle breakpoint changes
		document.querySelectorAll('.card-list-section').forEach((section) => {
			const $box = $(section).find('.card-list')
			if ($box.data('swiper-instance')) {
				$box.data('swiper-instance').destroy(true, true)
				$box.data('swiper-initialized', false)
				$box.data('swiper-instance', null)
			}
		})
		removeSwiperSlidesIfNeeded()
		initSwipers()
	})
})()
